var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var HistoryController = /** @class */ (function () {
    function HistoryController() {
    }
    /*****************************************************************************************************
        * Is using route "api/historyEntries/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {HistoryEntryDownloadDto[]}
    ******************************************************************************************************/
    HistoryController.GetHistoryEntries = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/historyEntries/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/history/data/{entryId}" and http method "GET" to call the back-end.
    
        * @param {string} entryId
        * @returns {HistoryEntryDownloadDto}
    ******************************************************************************************************/
    HistoryController.GetHistoryData = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/history/data/{entryId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/history/{entryId}" and http method "POST" to call the back-end.
    
        * @param {string} entryId
        * @returns {void}
    ******************************************************************************************************/
    HistoryController.SetCurrentHistoryEntry = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/history/{entryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/history/diff/{entryId}" and http method "POST" to call the back-end.
    
        * @param {string} entryId
        * @returns {DiffElement[]}
    ******************************************************************************************************/
    HistoryController.GetDiffToPreviousEntry = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/history/diff/{entryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/history/diff/{firstEntryId}/{secondEntryId}" and http method "POST" to call the back-end.
    
        * @param {string} firstEntryId
        * @param {string} secondEntryId
        * @returns {DiffElement[]}
    ******************************************************************************************************/
    HistoryController.GetDiffBetweenEntries = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/history/diff/{firstEntryId}/{secondEntryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/history/version/{dataId}" and http method "POST" to call the back-end.
    
        * @param {string} dataId
        * @returns {number}
    ******************************************************************************************************/
    HistoryController.GetCurrentVersionNumber = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/history/version/{dataId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return HistoryController;
}());
export { HistoryController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=HistoryController.js.map